import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Excerpt {
    constructor(element) {
        this.section = element;
        this.card = element.querySelector(".excerpt__card");
        this.content = element.querySelector(".excerpt__content");
        this.button = element.querySelector(".button");

        document.fonts.ready.then(() => {
            this.init();
        });
    }

    init() {
        if (!this.section.classList.contains("excerpt-main")) return;
        if (window.innerWidth < 1024) return;

        gsap.set(this.card, {
            scaleX: 0.6,
            scaleY: 0.6,
            transformOrigin: "center center",
        });

        const split = new SplitText(this.content.querySelector("h2"), {
            type: "lines",
            linesClass: "line-wrap",
        });

        gsap.set(split.lines, {
            rotationX: -100,
            transformOrigin: "50% 50% -160px",
            opacity: 0,
        });

        gsap.set(this.button, {
            opacity: 0,
            y: 80,
        });


        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.section,
                start: "clamp(center center)",
                end: "+=2000",
                scrub: 0.3,
                pin: true,
                markers: false,
            }
        });

        tl.to(this.card, {
            scaleX: 1,
            scaleY: 1,
            width: "100vw",
            height: "100vh",
            borderRadius: 0,
            duration: 2,
        })

        .to(split.lines, {
            rotationX: 0,
            transformOrigin: "50% 50% -160px",
            opacity: 1,
            ease: "power3",
            duration: 4.5,
            stagger: 0.5,
        })

        /* .to(this.button, {
            opacity: 1,
            y: 0,
            ease: "none",
            duration: 1.5,
        }, "-=1.5") */

        /* .to({}, { duration: 1.5 }); */
    }
}